import { Alert, Snackbar } from "@mui/material";
import { useRecoilState } from "recoil";
import { globalSnackbarState } from "../state";

const GlobalSnackbar = () => {
	const [snackbarState, setSnackbareState] = useRecoilState(globalSnackbarState);

	return (
		<Snackbar
			anchorOrigin={{
				vertical: "top",
				horizontal: "center",
			}}
			open={!!snackbarState}
			autoHideDuration={8000}
			onClose={() => setSnackbareState("")}
			sx={{
				zIndex: 9999,
				"> div > div": {
					textAlign: "center",
					whiteSpace: "pre-wrap",
				},
			}}
			style={{
				top: "35%",
			}}
		>
			<Alert onClose={() => setSnackbareState("")} severity="info" sx={{ width: "100%" }}>
				{snackbarState}
			</Alert>
		</Snackbar>
	);
};

export default GlobalSnackbar;
